import { z } from 'zod';
import { categorySchema, prioritySchema } from './enums.js';
// AI seed contract (SPEC §3.3). The model's output is validated against this
// before anything is persisted to the per-country staging tray. Each suggestion
// is a list item that may carry a location (since a list item is a map marker).
export const seedItemSchema = z.object({
    title: z.string().min(1).max(200),
    note: z.string().max(2000).nullable().optional(),
    priority: prioritySchema,
    category: categorySchema,
    lat: z.number().min(-90).max(90).nullable().optional(),
    lng: z.number().min(-180).max(180).nullable().optional(),
});
export const seedOutputSchema = z.object({
    items: z.array(seedItemSchema).max(60),
});
// Optional knobs supplied by the user when triggering a seed.
export const seedRequestSchema = z.object({
    interests: z.string().max(500).optional(),
});
// ---- Staging tray ----
export const stagedItemSchema = seedItemSchema.extend({ id: z.string() });
export const seedTraySchema = z.object({
    countryId: z.string(),
    generatedAt: z.string(),
    source: z.enum(['claude', 'stub']),
    items: z.array(stagedItemSchema),
});
export const seedAcceptSchema = z.object({
    id: z.string(),
});
//# sourceMappingURL=seed.js.map